<template>
  <RadioGroup v-model="checkedOption" class="flex flex-wrap gap-[8px]">
    <RadioGroupOption
        v-for="size in sizes"
        :key="size"
        v-slot="{ checked }"
        :value="size"
    >
      <span
          :class="[
          'cursor-pointer flex items-center justify-center border rounded-[4px] h-[34px] px-3 text-base font-medium border-grays-400',
          {
            'bg-primary-700 !text-primary-400': (checked || size === checkedOption) && !sizesNotInStock.includes(size),
            'border-[#B3B3B3] text-grays-500 bg-grays-300': sizesNotInStock.includes(size) && !(checked || size === checkedOption),
            'border-primary-700 bg-grays-400': (checked || size === checkedOption) && sizesNotInStock.includes(size),
          }
        ]"
      >
        {{ size }}
      </span>
    </RadioGroupOption>
  </RadioGroup>
</template>

<script>
import {RadioGroup, RadioGroupOption} from '@headlessui/vue';

export default {
  name: "RadioSelect",
  components: {
    RadioGroup,
    RadioGroupOption,
  },
  props: {
    sizes: {
      type: Array,
      required: true,
    },
    sizesNotInStock: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      checkedOption: this.sizes.length > 0 ? this.sizes[0] : null,
    };
  },
  emits: ['updateSelectedSize'],
  watch: {
    checkedOption(newVal) {
      this.$emit('updateSelectedSize', newVal);
    },
    sizes() {
      this.checkedOption = this.sizes.length > 0 ? this.sizes[0] : null;
    }
  },
};
</script>

<style scoped>
</style>
